import { TextTheme } from '@wix/thunderbolt-becky-types'
import { getFontWithoutColor, parseFontStr } from './fontsParser'
import { getFontFamilyWithFallbacks } from '@wix/thunderbolt-commons'

type FontShorthandParts = {
	style: string
	variant: string
	weight: string
	size: string
	family: string
}

const originalFontStringToObject = (fontStr: string, respectSizeUnit: boolean = false): FontShorthandParts => {
	const { style, variant, weight, size, sizeUnit = 'px', lineHeight, family } = parseFontStr(fontStr)
	const fontFamily = family.join(',')
	const sizeUnitToUse = respectSizeUnit ? sizeUnit : 'px'

	return {
		style,
		variant,
		weight,
		size: `${size}${sizeUnitToUse}/${lineHeight}`,
		family: fontFamily ? fixFontFamily(fontFamily) : '',
	}
}

export { getFontFamilyWithFallbacks }

const originalFontObjectToString = ({ style, variant, weight, size, family }: FontShorthandParts): string =>
	`${style} ${variant} ${weight} ${size} ${family}`.trim()

export const fixFontWithSpaceOrNotLatinChars = (font: string): string =>
	font.replace(/[^,]*[^\w,\d-][^,]*/g, (fontFamilyStr) => `'${fontFamilyStr.replace(/\+/g, ' ')}'`)

export const fixFontFamily = (fontFamily: string): string =>
	fixFontWithSpaceOrNotLatinChars(getFontFamilyWithFallbacks(fontFamily))

export const fixOriginalFont = ({
	font,
	respectSizeUnit = false,
}: {
	font: string
	respectSizeUnit?: boolean
}): string => {
	const fontWithoutColor = getFontWithoutColor(font)
	const parsedFont = originalFontStringToObject(fontWithoutColor, respectSizeUnit)

	return originalFontObjectToString(parsedFont)
}

export const textThemeToOriginalFont = (textTheme: TextTheme, { withColor = false } = {}): string => {
	const DEFAULT_VALUE = 'normal'
	const { fontSize, fontFamily, lineHeight, fontStyle, fontWeight, fontVariant, color } = textTheme
	const fontSizeAndLineHeight = lineHeight ? `${fontSize}/${lineHeight}` : fontSize
	return [
		fontStyle || DEFAULT_VALUE,
		fontVariant || DEFAULT_VALUE,
		fontWeight || DEFAULT_VALUE,
		fontSizeAndLineHeight,
		fontFamily || '',
		withColor ? color : '',
	]
		.join(' ')
		.trim()
}
